module.exports = __webpack_public_path__ + "media/a1.5899c94d.wav";